import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { CSS } from "@dnd-kit/utilities";
import { Form } from "react-bootstrap";
import { Popover } from "@mui/material";
import CurrencyInput from "react-currency-input-field";
import { NumericFormat } from "react-number-format";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { calPriceByMstCategoryPriceTax } from "utils/HelperFunction";
export var productStandardList = [
    {
        key: "sorting",
        render: function(param) {
            var customSort = param.customSort, setNodeRef = param.setNodeRef, attributes = param.attributes, listeners = param.listeners, item = param.item, setProductRow = param.setProductRow, index = param.index, transform = param.transform, transition = param.transition;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        style: customSort ? {
                            paddingLeft: 0
                        } : {},
                        children: customSort ? /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
                            style: {
                                paddingLeft: "14px",
                                transform: CSS.Transform.toString(transform),
                                transition: transition
                            },
                            ref: setNodeRef
                        }, attributes, listeners), {
                            children: /*#__PURE__*/ _jsx("div", {
                                className: "btn-drag"
                            })
                        })) : /*#__PURE__*/ _jsxs("div", {
                            className: "flex items-start ",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "mr-1",
                                    children: [
                                        index + 1,
                                        ". "
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("input", {
                                    className: "form-check-input",
                                    type: "checkbox",
                                    name: "",
                                    checked: item.is_checked,
                                    onChange: function(e) {
                                        if (e.target.checked === true) {
                                            setProductRow(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            is_checked: true
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        } else {
                                            setProductRow(function(prev) {
                                                return prev.map(function(el) {
                                                    if (el.rowID === item.rowID) {
                                                        return _object_spread_props(_object_spread({}, el), {
                                                            is_checked: false
                                                        });
                                                    }
                                                    return el;
                                                });
                                            });
                                        }
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "edit",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow, addProductRow = param.addProductRow, productSearch = param.productSearch, handleOnSelect = param.handleOnSelect, handleOnClear = param.handleOnClear, handleOnFocus = param.handleOnFocus, handleOnSearch = param.handleOnSearch, formatResult = param.formatResult, rowCount = param.rowCount, index = param.index;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !item.edit ? /*#__PURE__*/ _jsx("button", {
                            className: "btn btn-shadow fs-14",
                            style: {
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                minHeight: "35px"
                            },
                            onClick: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                edit: true
                                            });
                                        }
                                        return el;
                                    });
                                });
                                if (rowCount - index <= 2) {
                                    addProductRow(2);
                                }
                            },
                            children: item.productCode
                        }) : /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                            items: productSearch,
                            placeholder: "",
                            onSelect: function(items) {
                                return handleOnSelect(items, item.rowID);
                            },
                            onClear: handleOnClear,
                            onFocus: handleOnFocus,
                            onSearch: handleOnSearch,
                            autoFocus: true,
                            formatResult: formatResult,
                            fuseOptions: {
                                keys: [
                                    "barcode",
                                    "dimProduct.name_th"
                                ]
                            },
                            resultStringKeyName: "barcode",
                            inputSearchString: item.barcode,
                            styling: {
                                height: "34px",
                                borderRadius: "10px",
                                border: 0,
                                fontSize: "14px",
                                boxShadow: "none",
                                zIndex: 1
                            },
                            showIcon: false,
                            showClear: false,
                            className: "scrollSearchAutocomplete"
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productName",
        render: function(param) {
            var item = param.item;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productName
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productBarcode",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            if (!columdisplay.barcode) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productBarcode
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "supplierCode",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            if (!columdisplay.supplierCode) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("td", {
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "tc-15",
                                children: item.supplierCode
                            }),
                            /*#__PURE__*/ _jsx("br", {}),
                            item.supplierName
                        ]
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "warehouseID",
        render: function(param) {
            var item = param.item, values = param.values, optionsWarehouse = param.optionsWarehouse, setProductRow = param.setProductRow;
            var _item_warehouseID;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID && /*#__PURE__*/ _jsxs("select", {
                            value: (_item_warehouseID = item.warehouseID) !== null && _item_warehouseID !== void 0 ? _item_warehouseID : "",
                            style: {
                                width: "100%",
                                border: !item.warehouseID ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        var selectedOption = e.target.options[e.target.selectedIndex];
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                warehouseID: e.currentTarget.value,
                                                warehouseName: selectedOption.text
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            className: "form-control sselectv",
                            disabled: values.is_one_receiving_point,
                            children: [
                                /*#__PURE__*/ _jsx("option", {
                                    value: "",
                                    disabled: true,
                                    children: "เลือกคลัง"
                                }, "default"),
                                optionsWarehouse && optionsWarehouse.map(function(v, index) {
                                    return /*#__PURE__*/ _jsx("option", {
                                        value: v.value,
                                        children: v.label
                                    }, index);
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productUnit",
        render: function(param) {
            var item = param.item;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !!item.productUnit && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                item.productUnit,
                                /*#__PURE__*/ _jsx("br", {}),
                                "1X",
                                item.productRatioUnit
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productQty",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID != "" ? /*#__PURE__*/ _jsx("input", {
                            type: "number",
                            className: "form-control formv text-center border-0 me-2",
                            value: item.productQty,
                            onFocus: function(e) {
                                return e.target.select();
                            },
                            onWheel: function(e) {
                                return e.target.blur();
                            },
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                productQty: e.target.value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            }
                        }) : ""
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "ums",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            if (!columdisplay.ums) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 0,
                            fixedDecimalScale: true,
                            value: item.productRatioUnit * item.productQty
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "productsStock",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay;
            if (!columdisplay.productsStock) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        style: {
                            backgroundColor: "#EDEDFF"
                        },
                        children: item.productStock
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body  bg-EDEDFF "
                    })
                ]
            });
        }
    },
    {
        key: "productPrice",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID ? /*#__PURE__*/ _jsx(CurrencyInput, {
                            placeholder: "",
                            defaultValue: item.productPrice || 0,
                            value: item.productPrice,
                            decimalsLimit: 4,
                            // fixedDecimalLength={2}
                            decimalScale: 4,
                            onValueChange: function(value, name, values) {
                                // console.log(value);
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                productPrice: value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            className: "form-control formv text-end me-2"
                        }) : null
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "discount",
        render: function(param) {
            var item = param.item, index = param.index, anchorEl = param.anchorEl, setAnchorEl = param.setAnchorEl, popid = param.popid, setPopid = param.setPopid, setProductRow = param.setProductRow;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs("td", {
                        className: "position-reative",
                        id: "pop".concat(index),
                        children: [
                            /*#__PURE__*/ _jsxs("button", {
                                className: "btn w-100 btn-nhover",
                                type: "button",
                                id: "idd".concat(index),
                                style: {
                                    height: "34px"
                                },
                                variant: "contained",
                                onClick: function(e) {
                                    setPopid("sss2".concat(index));
                                    setAnchorEl(e.currentTarget);
                                },
                                children: [
                                    item.productID && (item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx(_Fragment, {
                                        children: item.discountType == 1 ? "".concat(item.discountPercent, " %") : item.discountType == 2 ? "บาท" : ""
                                    }),
                                    item.productID && !(item.discount > 0 || item.discountType == 2) && /*#__PURE__*/ _jsx("div", {
                                        style: {
                                            color: "#565DFF"
                                        },
                                        children: "เลือกส่วนลด"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Popover, {
                                id: "sss2".concat(index),
                                open: "sss2".concat(index) == popid,
                                anchorEl: anchorEl,
                                onClose: function() {
                                    setAnchorEl(null);
                                    setPopid(null);
                                },
                                anchorPosition: {
                                    left: 0,
                                    top: 0
                                },
                                container: document.getElementById("pop".concat(index)),
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "p-3 text-start ",
                                    style: {
                                        width: "260px",
                                        height: "160px"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-3",
                                            children: "เลือกรูปแบบส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "mb-2 d-flex align-items-center",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Check, {
                                                    inline: true,
                                                    label: "เปอร์เซ็นต์ %",
                                                    name: "",
                                                    type: "radio",
                                                    id: "x-radio-2".concat(index),
                                                    className: "form-check-st-2 tc-7",
                                                    checked: item.discountType == 1,
                                                    onChange: function(e) {
                                                        setProductRow(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        discountType: 1,
                                                                        discount: el.productPrice * parseFloat(el.discountPercent) / 100
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "number",
                                                    name: "",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: item.discountPercent,
                                                    style: {
                                                        width: "60px"
                                                    },
                                                    onChange: function(e) {
                                                        setProductRow(function(prev) {
                                                            return prev.map(function(el) {
                                                                if (el.rowID === item.rowID) {
                                                                    return _object_spread_props(_object_spread({}, el), {
                                                                        discountPercent: e.target.value,
                                                                        discount: el.productPrice * parseFloat(e.target.value) / 100
                                                                    });
                                                                }
                                                                return el;
                                                            });
                                                        });
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            children: /*#__PURE__*/ _jsx(Form.Check, {
                                                inline: true,
                                                label: "บาท",
                                                name: "",
                                                type: "radio",
                                                id: "x-radio-1".concat(index),
                                                className: "form-check-st-2 tc-7",
                                                checked: item.discountType == 2,
                                                onChange: function(e) {
                                                    setProductRow(function(prev) {
                                                        return prev.map(function(el) {
                                                            if (el.rowID === item.rowID) {
                                                                return _object_spread_props(_object_spread({}, el), {
                                                                    discountType: 2
                                                                });
                                                            }
                                                            return el;
                                                        });
                                                    });
                                                }
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "discountPrice",
        render: function(param) {
            var item = param.item, values = param.values, setProductRow = param.setProductRow;
            var _item_discount;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "text-end",
                        children: item.discountType == 1 ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 4,
                            fixedDecimalScale: true,
                            value: item.productPrice * parseFloat(item.discountPercent) / 100
                        }) : item.discountType == 2 ? /*#__PURE__*/ _jsx(CurrencyInput, {
                            placeholder: "",
                            defaultValue: (_item_discount = item.discount) !== null && _item_discount !== void 0 ? _item_discount : 0,
                            value: values.discount,
                            decimalsLimit: 4,
                            decimalScale: 4,
                            onValueChange: function(value, name, values) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                discount: value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            className: "form-control formv text-end me-2"
                        }) : null
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "optionsMstVat",
        render: function(param) {
            var item = param.item, optionsMstVat = param.optionsMstVat, setProductRow = param.setProductRow;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: item.productID ? /*#__PURE__*/ _jsx("select", {
                            value: item.dim_mst_vat_id,
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            var vat = optionsMstVat.find(function(v) {
                                                return v.value == e.currentTarget.value;
                                            });
                                            vat = vat ? vat.vat : 0;
                                            return _object_spread_props(_object_spread({}, el), {
                                                dim_mst_vat_id: e.currentTarget.value,
                                                vat: vat
                                            });
                                        }
                                        return el;
                                    });
                                });
                            },
                            className: "form-control sselectv",
                            children: optionsMstVat && optionsMstVat.map(function(v, index) {
                                return /*#__PURE__*/ _jsx("option", {
                                    value: v.value,
                                    children: v.label
                                }, index);
                            })
                        }) : null
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "valueExTax",
        render: function(param) {
            var item = param.item, values = param.values;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        className: "text-end",
                        children: /*#__PURE__*/ _jsx(_Fragment, {
                            children: !isNaN(item.productPrice) ? /*#__PURE__*/ _jsx(NumericFormat, {
                                displayType: "text",
                                thousandSeparator: ",",
                                decimalScale: 2,
                                fixedDecimalScale: true,
                                value: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, true)
                            }) : null
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "vat",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay, values = param.values;
            if (!columdisplay.vat) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !isNaN(item.productPrice) ? /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            value: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, false) - calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, true)
                        }) : null
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "valueIncludingTax",
        render: function(param) {
            var item = param.item, columdisplay = param.columdisplay, values = param.values;
            if (!columdisplay.valueIncludingTax) return null;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: !isNaN(item.productPrice) && /*#__PURE__*/ _jsx(NumericFormat, {
                            displayType: "text",
                            thousandSeparator: ",",
                            decimalScale: 2,
                            fixedDecimalScale: true,
                            value: calPriceByMstCategoryPriceTax(item, values.dim_mst_price_category_id, false)
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    },
    {
        key: "note",
        render: function(param) {
            var item = param.item, setProductRow = param.setProductRow;
            var _item_note;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx("td", {
                        children: /*#__PURE__*/ _jsx("input", {
                            type: "text",
                            className: "form-control formv text-start border-0 me-2",
                            value: (_item_note = item.note) !== null && _item_note !== void 0 ? _item_note : "",
                            onChange: function(e) {
                                setProductRow(function(prev) {
                                    return prev.map(function(el) {
                                        if (el.rowID === item.rowID) {
                                            return _object_spread_props(_object_spread({}, el), {
                                                note: e.target.value
                                            });
                                        }
                                        return el;
                                    });
                                });
                            }
                        })
                    }),
                    /*#__PURE__*/ _jsx("td", {
                        className: "column_resizer_body"
                    })
                ]
            });
        }
    }
];
